module.exports = __webpack_public_path__ + "static/media/20180905_174029.396f62b7.jpg";